import { makeStyles } from '@material-ui/styles';
import { Theme } from '@bizzabo/design-system';

import { DrawerNavigation } from './DrawerNavigation';
import { DrawerMyProfile } from './DrawerMyProfile';
import { DrawerProps } from './types';
import { DrawerNav } from './const';
import { DrawerContentRoute } from '../Components';
import { DrawerMySettings } from './DrawerMySettings';
import { DrawerMeetings } from './DrawerMeetings';

export const DrawerContent: React.FC<DrawerProps> = ({
    eventUniqueName,
    eventId,
    goToHomePage,
}) => {
    const classes = useStyles();
    return (
        <div className={classes.drawerContent}>
            <DrawerContentRoute to={DrawerNav.DEFAULT_NAVIGATION}>
                <DrawerNavigation
                    eventUniqueName={eventUniqueName}
                    eventId={eventId}
                    goToHomePage={goToHomePage}
                />
            </DrawerContentRoute>
            <DrawerContentRoute to={DrawerNav.MY_SETTINGS_CONTENT}>
                <DrawerMySettings eventUniqueName={eventUniqueName} />
            </DrawerContentRoute>
            <DrawerContentRoute to={DrawerNav.MY_PROFILE_CONTENT}>
                <DrawerMyProfile />
            </DrawerContentRoute>
            <DrawerContentRoute to={DrawerNav.MEETINGS_CONTENT}>
                <DrawerMeetings eventId={eventId} />
            </DrawerContentRoute>
        </div>
    );
};

export const useStyles = makeStyles<Theme>(
    () => ({
        drawerContent: {
            width: '100%',
            height: '100%',
            overflowY: 'auto',
        },
    }),
    { classNamePrefix: 'navigation-drawer-content' }
);
